import { Checkbox } from "../core/form/Checkbox";
import { DataContext, useData, useDataContext, useDataValue } from "../core/hooks/useData";
import { Icon } from "../core/ui/icons";
import { closestKey } from "../core/utils/dom";
import { SuccessionPlanElement } from "./types";

const options = [
	{ id: "spouse", name: "Spouse" },
	{ id: "children", name: "Children" },
	{ id: "lpr", name: "LPR" },
	{ id: "other", name: "Other" },
];


export function SuccessionPlan(props: {
	def: SuccessionPlanElement,
}) {

	const data = useData();
	let value = useDataValue(data, props.def.id);
	if (!value) value = [];

	// have a data state specific for this component
	const thisDataState = useDataContext<any>({});

	function createOption(o: any, selected: boolean) {
		return (
			<div
				key={o.id}
				className={"item flex horiz " + (selected ? "selected" : "")}
			>
				<Checkbox
					title={o.name}
					prop={o.id}
					data-key={o.id} 
					onChange={(e, newValue) => {
						if (!newValue) {
							const index = value.indexOf(o.id);
							value.splice(index, 1);
						} else {
							value.push(o.id);
						}
						
						data.setValue(props.def.id, [...value]);
				
					}}
				/>
				{selected && <button className="flat" onClick={() => order(o.id, -1)}><Icon type="arrowUp" /></button>}
				{selected && <button className="flat" onClick={() => order(o.id, 1)}><Icon type="arrowDown" /></button>}
			</div>
		);
	}

	function order(id: string, dir: number) {
		const index = value.indexOf(id);
		const item = value[index];
		value.splice(index, 1);
		value.splice(index + dir, 0, item);

		data.setValue(props.def.id, [...value]);
	}

	const items = [];

	// want to draw the ones first which are checked
	// and in the order they appear in the value array
	for(let v of value) {
		// find option
		for(let o of options) {
			if (o.id === v) {
				items.push(createOption(o, true));
				break;
			}
		}		
	}

	for(let o of options) {
		const selected = (value.indexOf(o.id) >= 0);
		thisDataState.value[o.id] = selected;
		if (selected) continue;

		items.push(createOption(o, false));
	}

	return (
		<DataContext.Provider value={thisDataState}>
			<div
				className="succession-plan"
			>
				{items}
			</div>
		</DataContext.Provider>
	);
}